import { render } from "./WYSIWYGEditor.vue?vue&type=template&id=570e6870&scoped=true&ts=true"
import script from "./WYSIWYGEditor.vue?vue&type=script&lang=ts"
export * from "./WYSIWYGEditor.vue?vue&type=script&lang=ts"

import "./WYSIWYGEditor.vue?vue&type=style&index=0&id=570e6870&lang=scss&scoped=true"
import "./WYSIWYGEditor.vue?vue&type=style&index=1&id=570e6870&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570e6870"]])

export default __exports__